webshop.ProductList = class {
	/* Options:
		- items: Items
		- settings: Webshop Settings
		- products_section: Products Wrapper
		- preference: If preference is not list view, render but hide
	*/
	constructor(options) {
		Object.assign(this, options);

		if (this.preference !== "List View") {
			this.products_section.addClass("hidden");
		}

		this.products_section.empty();
		this.make();
	}

	make() {
		let me = this;
		let html = `<br><br>`;

		this.items.forEach(item => {
			let title = item.web_item_name || item.item_name || item.item_code || "";
			title =  title.length > 200 ? title.substr(0, 200) + "..." : title;

			html += `<div class='row list-row w-100 mb-4 px-3 px-md-4 position-relative'>`;
			html += me.get_image_html(item, title, me.settings);
			html += me.get_row_body_html(item, title, me.settings);
			html += `</div>`;
		});

		let $product_wrapper = this.products_section;
		$product_wrapper.append(html);

		// Fetch exact quantities from backend to update the red bubbles dynamically
		this.update_quantities_from_cart();
	}

	// Updates the red bubbles with actual quantities from the Cart
	update_quantities_from_cart() {
		if (frappe.session.user !== "Guest") {
			frappe.call({
				method: "webshop.webshop.shopping_cart.cart.get_cart_quotation",
				callback: function(r) {
					let items = (r.message && r.message.doc) ? r.message.doc.items : (r.message ? r.message.items : null);
					
					if (items && items.length > 0) {
						items.forEach(cart_item => {
							let $badge = $(`.cart-indicator[data-item-code="${cart_item.item_code}"]`);
							if ($badge.length) {
								$badge.text(cart_item.qty);
							}
						});
					}
				}
			});
		}
	}

	get_image_html(item, title, settings) {
		let image = item.website_image;
		let wishlist_enabled = !item.has_variants && settings.enable_wishlist;
		
		// FIXED: Added p-md-2 so the image gets some padding inside its border on desktop only
		let image_html = `<div class="col-4 col-md-2 border text-center rounded list-image p-0 p-md-2 position-relative overflow-hidden">`;

		if (image) {
			image_html += `
				<a class="product-link product-list-link d-block h-100 w-100" href="/${ item.route || '#' }">
					<img itemprop="image" class="website-image h-100 w-100" style="object-fit: contain;" alt="${ title }" src="${ image }">
				</a>`;
		} else {
			image_html += `
				<a class="product-link product-list-link d-block h-100 w-100" href="/${ item.route || '#' }" style="text-decoration: none">
					<div class="card-img-top no-image-list d-flex align-items-center justify-content-center h-100">
						${ frappe.get_abbr(title) }
					</div>
				</a>`;
		}

		if (wishlist_enabled) {
			image_html += `
				<div class="btn btn-sm btn-light p-1 rounded-circle like-action-list position-absolute shadow-sm ${ item.wished ? 'like-action-wished' : '' }" 
					 data-item-code="${ item.item_code }" 
					 style="top: 4px; left: 4px; z-index: 9;">
					<svg class="icon sm">
						<use class="${ item.wished ? 'wished' : 'not-wished' } wish-icon" href="#icon-heart"></use>
					</svg>
				</div>`;
		}

		image_html += `</div>`;
		return image_html;
	}

	get_row_body_html(item, title, settings) {
		let body_html = `<div class='col-8 col-md-10 text-left d-flex flex-column pl-3 pr-0 px-md-3'>`;
		
		body_html += `<div class="row m-0 w-100">`;
		
		body_html += `<div class="col-12 col-md-8 p-0 pr-md-3">`;
		body_html += this.get_title_html(item, title, settings);
		body_html += this.get_item_details(item, settings);
		body_html += this.get_price_html(item, settings);
		body_html += `</div>`;
		
		if (settings.enabled) {
			body_html += `<div class="col-12 col-md-4 p-0 mt-3 mt-md-0 cart-action-container d-flex flex-column align-items-start align-items-md-end ${item.in_cart ? 'd-flex' : ''}">`;
			body_html += this.get_primary_button(item, settings);
			body_html += `</div>`;
		}
		
		body_html += `</div></div>`;
		return body_html;
	}

	get_title_html(item, title, settings) {
		return `
			<a class="d-block mb-1 product-title" href="/${ item.route || '#' }" style="color: var(--gray-800); font-weight: 500; font-size: 1.05rem; line-height: 1.2;">
				${ title }
			</a>
			<!-- Mobile Only Category -->
			<div class="text-muted mb-2 d-md-none" style="font-size: 0.85rem;">
				${ item.item_group }
			</div>
		`;
	}

	get_item_details(item, settings) {
		return `
			<div class="d-none d-md-block">
				<p class="product-code text-muted mb-1" style="font-size: 13px;">
					${ item.item_group } | ${ __('Item Code') } : ${ item.item_code }
				</p>
				<div class="mt-2 text-muted" style="font-size: 13px;">
					${ item.short_description || '' }
				</div>
			</div>
		`;
	}

	get_price_html(item, settings) {
		let details = `
			<div class="product-price font-weight-bold mt-1 mt-md-3" itemprop="offers" itemscope itemtype="https://schema.org/AggregateOffer">
				${ item.formatted_price || '' }
		`;

		if (item.formatted_mrp) {
			details += `
				<small class="striked-price text-muted ml-1">
					<s>${ item.formatted_mrp ? item.formatted_mrp.replace(/ +/g, "") : "" }</s>
				</small>
				<small class="ml-1 product-info-green">
					${ item.discount } ${ __("OFF") }
				</small>
			`;
		}

		details += this.get_stock_availability(item, settings);
		details += `</div>`;

		return details;
	}

	get_stock_availability(item, settings) {
		if (settings.show_stock_availability && !item.has_variants) {
			if (item.on_backorder) {
				return `<div class="out-of-stock mt-1" style="color: var(--primary-color); font-size: 0.8rem;">${ __("Available on backorder") }</div>`;
			} else if (!item.in_stock) {
				return `<div class="out-of-stock mt-1" style="font-size: 0.8rem;">${ __("Out of stock") }</div>`;
			} else if (item.is_stock) {
				return `<div class="in-stock in-green has-stock mt-1" style="font-size: 0.8rem;">${ __("In stock") }</div>`;
			}
		}
		return ``;
	}

	get_primary_button(item, settings) {
		if (item.has_variants) {
			return `
				<a href="/${ item.route || '#' }" class="w-100 w-md-auto d-block">
					<div class="btn btn-sm btn-primary btn-explore-variants w-100 w-md-auto mb-0 mt-0">
						${ __("Explore") }
					</div>
				</a>
			`;
		} else if (settings.enabled && (settings.allow_items_not_in_stock || item.in_stock)) {
			return `
				<div class="d-flex flex-column flex-md-row justify-content-md-end w-100 w-md-auto mt-2 mt-md-0">
					
					<!-- ADD BUTTON -->
					<div id="${ item.name }" class="btn btn-sm btn-primary btn-add-to-cart-list w-100 w-md-auto mb-0 mr-md-2 ${ item.in_cart ? 'hidden' : '' }"
							data-item-code="${ item.item_code }"
							style="max-height: 32px; padding: 0.25rem 1rem;">
						<span class="mr-1">
							<svg class="icon icon-sm"><use href="#icon-assets"></use></svg>
						</span>
						${ __("Add to Cart") }
					</div>

					<!-- GO TO CART / QUOTE BUTTON -->
					<a href="/cart" class="w-100 w-md-auto text-decoration-none mt-2 mt-md-0">
						<div id="${ item.name }" class="btn btn-sm btn-primary btn-add-to-cart-list go-to-cart w-100 w-md-auto px-3 m-0 position-relative ${ item.in_cart ? '' : 'hidden' }"
							data-item-code="${ item.item_code }">
							${ __("Go to Cart") }
							
							<!-- NOTIFICATION STYLE QUANTITY BADGE (RED) -->
							<div class="cart-indicator list-indicator position-absolute text-white rounded-circle d-flex align-items-center justify-content-center shadow-sm ${ item.in_cart ? '' : 'hidden' }" 
								 data-item-code="${ item.item_code }" 
								 style="background-color: #dc3545; width: 20px; height: 20px; font-size: 11px; top: -8px; right: -8px; z-index: 10; line-height: 1;">
								${ item.cart_qty || 1 }
							</div>
						</div>
					</a>
				</div>
			`;
		} else {
			return ``;
		}
	}
};